export const CONFLUENCE_FLAG_TO_SHARE_ACTION_EVENT = 'confluence:twcg-2055:flag-to-share-action';

export type ConfluenceFlagToShareContentType = 'live-doc' | 'whiteboard' | 'database';
export type ConfluenceFlagToShareAction = 'openShareDialog' | 'copyShareLink';

export type ConfluenceFlagToShareActionDetail = {
	action: ConfluenceFlagToShareAction;
	contentId: string;
	contentType: ConfluenceFlagToShareContentType;
};

export const dispatchConfluenceFlagToShareAction = (
	detail: ConfluenceFlagToShareActionDetail,
): boolean => {
	const browserWindow = globalThis.document?.defaultView;
	if (!browserWindow) {
		return false;
	}

	const actionEvent = new CustomEvent<ConfluenceFlagToShareActionDetail>(
		CONFLUENCE_FLAG_TO_SHARE_ACTION_EVENT,
		{
			cancelable: true,
			detail,
		},
	);
	browserWindow.dispatchEvent(actionEvent);
	return actionEvent.defaultPrevented;
};
